<script setup>
import { useVModel } from "@vueuse/core";
import { cn } from "@/shared/lib/utils";

defineOptions({ inheritAttrs: false });

const props = defineProps({
  defaultValue: { type: [String, Number], default: undefined },
  modelValue: { type: [String, Number], default: undefined },
  class: { type: [String, Object, Array], default: undefined },
  size: { type: String, default: "default" },
  clearable: { type: Boolean, default: false },
});

const emit = defineEmits(["update:modelValue"]);

const modelValue = useVModel(props, "modelValue", emit, {
  passive: true,
  defaultValue: props.defaultValue,
});

function clear() {
  modelValue.value = "";
}
</script>

<template>
  <div v-if="clearable" class="relative w-full">
    <input
      v-bind="$attrs"
      v-model="modelValue"
      data-slot="input"
      :data-size="size"
      :class="
        cn(
          'text-foreground file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-border/30 border-input w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          'focus-visible:border-primary ',
          'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
          'data-[size=lg]:h-10 data-[size=default]:h-9 data-[size=sm]:h-8 bg-background',
          'pr-7',
          props.class
        )
      "
    />
    <button
      v-if="modelValue"
      type="button"
      class="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
      @click="clear"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
      </svg>
    </button>
  </div>
  <input
    v-else
    v-bind="$attrs"
    v-model="modelValue"
    data-slot="input"
    :data-size="size"
    :data-filled="modelValue !== '' && modelValue != null ? '' : undefined"
    :class="
      cn(
        'text-foreground file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-border/30 border-input w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        'focus-visible:border-primary ',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        'data-[size=lg]:h-10 data-[size=default]:h-9 data-[size=sm]:h-8 bg-background',
        props.class
      )
    "
  />
</template>
